import React, { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import DynamicForm from "./DynamicForm";
import LoaderComponent from "../../../libraries/loader/loader";
import { Fetchexecutequery, Fetchheaderdata, Fetchupdatequery } from "../../../services/process/BRS1/brsService7";
import { CreateData } from "../../../services/process/process_data/process_data";
import { Icon } from "semantic-ui-react";
import { IonIcon } from "@ionic/react";
import * as allIcons from "ionicons/icons";

const ionIconsList = Object.keys(allIcons).filter(
  (key) => typeof allIcons[key] === "string" && key.endsWith("Outline")
);

function DepartmentCreation() {
  const [formData, setFormData] = useState({});
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [filterconditions, setFilterconditions] = useState([
    {
      is_active: 1,
      entity_id: userCredentials.entities_id,
      tenant_id: userCredentials.tenants_id,
      group_id: userCredentials.groups_id,
    },
  ]);
  const [fields, setFields] = useState(null);
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [selectedIcon, setSelectedIcon] = useState(null);
  const [search, setSearch] = useState("");

  const filteredIcons = ionIconsList.filter((icon) =>
    icon.toLowerCase().includes(search.toLowerCase())
  );

  const getFormattedDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().slice(0, 19).replace("T", " ");
  };

  useEffect(() => {
    fetchFieldInfo1();
    fetchFieldInfo2();
  }, []);

  const formatColumnName = (name) =>
    name.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchFieldInfo1 = async () => {
    const payload = { headerconfig_id: 49, filterconditions };

    try {
      const FileUploadCredentials = Fetchheaderdata();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data.fields && data.fields.length > 0) {
        const columns = data.fields.map((field) => ({
          headerName: formatColumnName(field.columnName),
          field: field.columnName,
          filter: true,
          sortable: true,
          resizable: true,
        }));

        columns.push({
          headerName: "Edit",
          field: "edit",
          cellRendererFramework: (params) => (
            <Icon
              name="edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleEditClick(params.data)}
            />
          ),
          width: 100,
        });

        setColumnDefs(columns);
        setFields(data.fields);
      }
    } catch (error) {
      console.error("Error fetching field info:", error);
      setError("Error fetching fields data");
    }
    setLoading(false);
  };

  const fetchFieldInfo2 = async () => {
    const payload = { query: `SELECT * FROM user_management.pages WHERE is_active=1;` };

    try {
      const FileUploadCredentials = Fetchexecutequery();
      const response = await axios.post(
        FileUploadCredentials[1],
        payload,
        FileUploadCredentials[0]
      );

      const data = response.data;
      if (data && data.length > 0) {
        setRowData(data);
      }
    } catch (error) {
      console.error("Error fetching department data:", error);
      setError("Error fetching department data");
    }
  };

  const handleEditClick = (row) => {
    console.log("edit row ",row);
    setFormData(row);
     let configObj = row.config;

  if (typeof row.config === "string") {
    try {
      configObj = JSON.parse(row.config);
    } catch (e) {
      console.error("Failed to parse config:", e);
      configObj = {};
    }
  }

  if (configObj) {
    console.log("Parsed config", configObj);
    setFirstValue(configObj.name || "");
    setSecondValue(configObj.sideMenu || "");
    setSelectedIcon(configObj.iconName || null);
  }
    setEditMode(true);
  };

  const handleCreate = () => {
    const formattedDate = getFormattedDate();
    const updatedFormData = {
      ...formData,
      config_json: {
        name: firstValue,
        iconName: selectedIcon,
        sideMenu: secondValue,
      },
      created_date: formattedDate,
      modified_date: formattedDate,
      is_active: 1,
      created_by_user_id: userCredentials.user_id,
      modified_by_user_id: userCredentials.user_id,
    };

    const payload = {
      database: "user_management",
      table: "pages",
      formData: updatedFormData,
    };

    const FileUploadCredentials = CreateData();

    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => {
        fetchFieldInfo2();
        resetForm();
      })
      .catch((error) => {
        console.error("Error creating data:", error);
        setError("Error creating data");
      });
  };

  const handleUpdate = () => {
    const updatedFormData = {
      ...formData,
      config_json: {
        name: firstValue,
        iconName: selectedIcon,
        sideMenu: secondValue,
      },
    };

    const payload = {
      schema_name: "user_management",
      table: "pages",
      set_column: updatedFormData,
      where: [{ primary_id: formData.primary_id }],
    };

    const FileUploadCredentials = Fetchupdatequery();

    axios
      .post(FileUploadCredentials[1], payload, FileUploadCredentials[0])
      .then(() => {
        setEditMode(false);
        fetchFieldInfo2();
        resetForm();
      })
      .catch((error) => {
        console.error("Error updating data:", error);
        setError("Error updating data");
      });
  };

  const resetForm = () => {
    setFormData({});
    setFirstValue("");
    setSecondValue("");
    setSelectedIcon(null);
  };

  const handleInputChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (editMode) {
      handleUpdate();
    } else {
      handleCreate();
    }
  };

  if (loading) return <LoaderComponent loaderOpen={true} />;

  return (
    <div style={{ margin: "20px" }}>
      <h2 className="pt-1 pb-1 text-center" style={{ color: "#4969ab", fontSize: "18px" }}>
        PAGES
      </h2>

      {error && <div style={{ color: "red" }}>{error}</div>}

      <DynamicForm fields={fields} formData={formData} onInputChange={handleInputChange} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          margin: "20px",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", gap: "10px", justifyContent: "space-between" }}>
          <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
            <label style={{ marginBottom: "5px", fontSize: "14px", fontWeight: "bold" }}>URL Name</label>
            <input
              type="text"
              placeholder="Enter URL name..."
              value={firstValue}
              onChange={(e) => setFirstValue(e.target.value)}
              style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", flex: "1" }}>
            <label style={{ marginBottom: "5px", fontSize: "14px", fontWeight: "bold" }}>Side Menu Name</label>
            <input
              type="text"
              placeholder="Enter Side Menu name..."
              value={secondValue}
              onChange={(e) => setSecondValue(e.target.value)}
              style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
            />
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <label style={{ marginBottom: "5px", fontSize: "14px", fontWeight: "bold" }}>Search Icons</label>
          <input
            type="text"
            placeholder="Search icons..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ padding: "10px", borderRadius: "8px", border: "1px solid #ccc" }}
          />
          <div style={{ display: "flex", flexWrap: "wrap", marginTop: "10px" }}>
{filteredIcons.map((iconKey) => {
    const formattedName = iconKey
      .replace(/Outline$/, "")
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space between camelCase words
      .replace(/^./, (str) => str.toUpperCase()); // Capitalize first letter

    return (
      <div
        key={iconKey}
        onClick={() => setSelectedIcon(iconKey)}
        style={{
          cursor: "pointer",
          padding: "10px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: selectedIcon === iconKey ? "2px solid #007bff" : "1px solid #ddd",
          borderRadius: "8px",
          backgroundColor: selectedIcon === iconKey ? "#e6f0ff" : "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          fontSize: "12px",
          textAlign: "center",
        }}
      >
        <IonIcon icon={allIcons[iconKey]} style={{ fontSize: "24px", marginBottom: "6px",color: selectedIcon === iconKey ? "#007bff" : "#333", }} />
        <span style={{ wordBreak: "break-word", lineHeight: "1.2" }}>{formattedName}</span>
      </div>
    );
  })}
</div>
        </div>

        <div style={{ marginTop: "10px" }}>
          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 20px",
              backgroundColor: "#4969ab",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            {editMode ? "Update" : "Create"}
          </button>
        </div>
      </div>

      <div className="ag-theme-alpine" style={{ height: 400, width: "100%", marginTop: "20px" }}>
        <AgGridReact rowData={rowData} columnDefs={columnDefs} pagination paginationPageSize={10} />
      </div>
    </div>
  );
}

export default DepartmentCreation;
